import React, {useMemo, useState} from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import RouterPath from "libs/RouterPath";
import {DemandValidation} from 'constants/DemandValidation';
import isPublishButtonActive from 'libs/isPublishButtonActive';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import DemandService from "services/DemandService";
import PublishService from "services/PublishService";
import HeaderService from "services/HeaderService";
import Confirm from "components/popup/confirm/Confirm";
import Loading from "components/Loading";
import GridBlock from 'components/GridBlock';
import {clearResource} from "redux/actions";
import clsx from "clsx";
import Icon from "@material-ui/icons/CheckBox";
import IconOff from "@material-ui/icons/HighlightOff";
import {isDemandFinished, isDemandFinishing} from "libs/getDemandStatus";

const style = theme => ({
    root: {
        '&>*': {
            '&>*': {
                marginTop: theme.spacing(2)
            }
        }
    },

    hidden: {
        display: 'none'
    },

    finishButton: {
        marginTop: theme.spacing(2)
    }
})

function ExPostGoToFinish(
    {
        match,
        classes,
        demandValidation,
        ojsPublicationStatus,
        isDemandChanged = {}
    }) {

    const id = match.params.id;
    const rp = RouterPath.myProcedure;

    const [openGoToFinishPopup, setOpenGoToFinishPopup] = useState(false);
    const [working, setWorking] = useState(false);

    const findSection = (compareSection) => demandValidation.find(x => x.section === compareSection);
    const section = findSection(DemandValidation.EX_POST_GO_TO_FINISH);

    const editable = section ? section.editable : false;
    const isPublishActive = useMemo(() => isPublishButtonActive(demandValidation, ojsPublicationStatus, isDemandChanged), [demandValidation, ojsPublicationStatus, isDemandChanged]);
    const isDemandFinish = useMemo(() => isDemandFinished() || isDemandFinishing(), []);

    const handleGoToFinish = () => {
        setOpenGoToFinishPopup(false);
        setWorking(true);
        PublishService.publishExPost(id).then((resp) => {
            if (resp != null) {
                if (resp) {
                    HeaderService.get(id);
                    PublishService.markFirstPublication(id);
                    const href = RouterPath.createPath(rp.steps.MP_4_ID, {id});
                    RouterPath.redirect(href)
                } else {
                    setWorking(false);
                }
            } else {
                setWorking(false);
                DemandService.getValidate(id, false);
            }
        });
    };

    return (
        <>
            {working && <Loading/>}

            <GridBlock
                direction='column'
                alignItems='center'
                className={clsx({[classes.hidden]: working})}
            >
                {
                    isPublishActive || isDemandFinish ?
                        <Icon className={classes.icon} color='primary'/>
                        :
                        <IconOff className={classes.icon} color='primary'/>
                }
                <Typography variant='h5'>
                    {isDemandFinish ? Tr('p1_pf_1_epf') : (isPublishActive ? Tr('p1_pf_1') : Tr('p1_pf_1_f'))}
                </Typography>

                <Button
                    className={classes.finishButton}
                    disabled={!editable || !isPublishActive}
                    onClick={() => setOpenGoToFinishPopup(true)}
                >
                    {Tr('exPost_goToFinish')}
                </Button>

                <Confirm
                    open={openGoToFinishPopup}
                    onConfirm={handleGoToFinish}
                    onCancel={() => setOpenGoToFinishPopup(false)}
                    confirmText={Tr('exPost_goToFinish_confirm')}
                />
            </GridBlock>
        </>
    )
}

ExPostGoToFinish.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
}), {
    clearResource
})(withStyles(style)(withRouter(ExPostGoToFinish)));